module.exports = __webpack_public_path__ + "static/media/DWB-dimming.dfed2124.png";